import { Box, Typography, Button, Container, Paper, IconButton } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import ExploreIcon from '@mui/icons-material/Explore'

const NotFoundPage = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  return (
    <Box
      sx={{
        backgroundColor: '#0A192F', // Deep Navy Midnight
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 3,
        backgroundImage: 'radial-gradient(circle at 2px 2px, rgba(255,255,255,0.05) 1px, transparent 0)',
        backgroundSize: '40px 40px', // Subtle subtle grid pattern
      }}
    >
      <Container maxWidth='sm'>
        <Paper
          elevation={0}
          sx={{
            backgroundColor: 'rgba(255, 255, 255, 0.03)',
            backdropFilter: 'blur(10px)',
            border: '1px solid rgba(255, 255, 255, 0.1)',
            borderRadius: 4,
            p: { xs: 4, md: 8 },
            textAlign: 'center',
            color: 'white'
          }}
        >
          {/* Subtle Icon Header */}
          <ExploreIcon sx={{ fontSize: 40, mb: 2, color: '#4A90E2', opacity: 0.8 }} />

          <Typography
            variant='h1'
            sx={{
              fontWeight: 800,
              fontSize: { xs: '5rem', md: '7rem' },
              letterSpacing: -2,
              mb: 0,
              lineHeight: 1,
              color: '#ffffff'
            }}
          >
            404
          </Typography>

          <Typography
            variant='body1'
            sx={{
              mb: 5,
              color: 'rgba(255, 255, 255, 0.6)',
              fontSize: '1.1rem',
              lineHeight: 1.7
            }}
          >
            {t('notfound.text', 'The link may be broken or the page has been moved to a restricted directory.')}
          </Typography>

          <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
            <IconButton 
              onClick={() => navigate(-1)}
              sx={{ 
                color: 'white', 
                border: '1px solid rgba(255, 255, 255, 0.2)',
                '&:hover': { backgroundColor: 'rgba(255,255,255,0.1)' }
              }}
            >
              <ArrowBackIcon />
            </IconButton>
            
            <Button
              variant='contained'
              onClick={() => navigate('/')}
              sx={{
                backgroundColor: '#ffffff',
                color: '#0A192F',
                fontWeight: 700,
                px: 4,
                borderRadius: 2,
                '&:hover': {
                  backgroundColor: '#e0e0e0',
                }
              }}
            >
              {t('notfound.buttonText', 'Return to Home')}
            </Button>
          </Box>
        </Paper>
      </Container>
    </Box>
  )
}

export default NotFoundPage